export default __webpack_public_path__ + "static/media/warningIcon.309d5d4c.svg";